// Function to format social medias name to http links
export function formatInstagram(text) {
    if (typeof text != 'string') throw new Error('Invalid instagram name');

    const formatedText = text.startsWith('@') ? text.slice(1) : text;

    return `https://www.instagram.com/${formatedText}/`;
}

export function formatWhatsApp(text) {
    if (typeof text != 'string') throw new Error('Invalid intagram name');

    const formatedText = text.trim().replace(/^\+/, '').replace(/\s+/g, '');

    return `https://wa.me/${formatedText}`;
}
